import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { refreshToken as refreshTokenThunk } from "../../slices/auth";
import { Helmet } from "react-helmet";

function AutoLogin() {
  var { search } = useLocation();
  var dispatch = useDispatch();
  var [redirectTo, setRedirectTo] = useState(null);
  var [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    setErrorMessage(null);

    const urlSearchParams = new URLSearchParams(search);
    const refreshTokenParam = urlSearchParams.get("refreshToken");
    const requestedRedirect = urlSearchParams.get("url");
    const fallbackRedirect = "/dashboard";

    const resolveRedirectTarget = () => {
      if (!requestedRedirect) {
        return fallbackRedirect;
      }

      const trimmed = requestedRedirect.trim();
      if (!trimmed) {
        return fallbackRedirect;
      }

      try {
        const parsed = new URL(trimmed, window.location.origin);

        if (parsed.origin !== window.location.origin) {
          return fallbackRedirect;
        }

        if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
          const pathWithQuery = `${parsed.pathname}${parsed.search}${parsed.hash}`;
          return pathWithQuery || fallbackRedirect;
        }

        return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
      } catch (error) {
        return fallbackRedirect;
      }
    };

    if (refreshTokenParam) {
      let isCancelled = false;

      const performRefresh = async () => {
        try {
          await dispatch(refreshTokenThunk(refreshTokenParam)).unwrap();

          if (isCancelled) {
            return;
          }

          var redirect = resolveRedirectTarget();
          console.log("redirecting to: " + redirect);
          setRedirectTo(redirect);

        } catch (error) {
          if (!isCancelled) {
            setErrorMessage("Automatic login failed.");
          }
        }
      };

      performRefresh();

      return () => {
        isCancelled = true;
      };
    } else {
      setErrorMessage("Missing refresh token.");
    }
  }, [search]);

  return (
    <div>
      <Helmet>
        <title>Auto Login | GetUpp Play</title>
        <meta
          name="description"
          content="Securely authenticate and jump straight into your GetUpp Play dashboard."
        />
      </Helmet>
      {redirectTo && <Redirect push to={redirectTo} />}
      {!redirectTo && !errorMessage && <div>Logging in...</div>}
      {!redirectTo && errorMessage && <div>{errorMessage}</div>}
    </div>
  );
}

export default AutoLogin;
